import Vue from "vue";
import Moment from "moment";
import helper from "@/config/helper";

const state = {
	trigger: null,
	serviceRating: 0,
	productRating: 0,
	serviceMessage: null,
	productMessage: null,
}

const actions = {
	saveFeedback({ state, dispatch, commit, rootGetters }){
		const credentials		= rootGetters['auth/getCredentials'];
		const merchant_number	= rootGetters['subscriptionDetail/getMerchantNumber'];
		const subscription_id	= rootGetters['subscriptionDetail/getSubscriptionId'];

		const serviceMessage = helper.sanitizeUtfmb4(state.serviceMessage);
		const productMessage = helper.sanitizeUtfmb4(state.productMessage);

		const data = new FormData();

		data.append("method",			"saveFeedback");
		data.append("email",			credentials.email);
		data.append("code",				credentials.code);
		data.append("token",			credentials.token);
		data.append("merchant_number",	merchant_number);
		data.append("subscription_id",	subscription_id);
		data.append("trigger",			state.trigger ?? "non_respondent");
		data.append("service_rating",	state.serviceRating);
		data.append("product_rating",	state.productRating);
		data.append("service_message",	serviceMessage);
		data.append("product_message",	productMessage);

		helper
			.axios()
			.post("", data)
			.then(() => {
				dispatch("unsetFeedback");
			
				const now = Moment().format("YYYY-MM-DD");
				commit("subscriptionDetail/setLastFeedback", now, { root: true });

				Vue.$toast.success("Agradecemos o seu feedback!", { position: "top-right" });
			})
			.catch((error) => {
				helper.callback_error(error);
			})
			.finally(() => {
				commit("setLoading", false, { root: true });
			});
	},

	setFeedback({ commit, rootState }, content){
		let lastFeedback = rootState.subscriptionDetail.last_feedback;

		if(lastFeedback == null){
			commit("setTrigger", content);
			return;
		}

		lastFeedback = Moment(lastFeedback);
		let feedbackLimit = Moment().subtract(90, 'days').format("YYYY-MM-DD");

		if(!lastFeedback.isBefore(feedbackLimit)){
			return;
		}

		commit("setTrigger", content);
	},

	showFeedbackModal({ state, commit }){
		if(state.trigger == null){
			return;
		}

		commit("modals/setDialogFeedback", true, { root: true });
	},

	unsetFeedback({ commit }){
		commit("modals/setDialogFeedback", false, { root: true });
		commit("unsetFeedback");
	}
}

const mutations = {
	unsetFeedback(state){
		state.trigger			= null;
		state.serviceRating		= 0;
		state.productRating		= 0;
		state.serviceMessage	= null;
		state.productMessage	= null;
	},

	setTrigger(state, content){
		state.trigger = content;
	},

	setServiceRating(state, content){
		state.serviceRating = content;
	},

	setProductRating(state, content){
		state.productRating = content;
	},

	setServiceMessage(state, content){
		state.serviceMessage = content;
	},

	setProductMessage(state, content){
		state.productMessage = content;
	}
}

const getters = {
	shouldShowFeedbackModal(state, _, rootState){
		return state.trigger != null && 
				rootState.modals.dialogEditProducts == false && 
					rootState.modals.dialogPaymentMethod == false && 
						rootState.modals.dialogRemoveCardConfirmation == false && 
							rootState.modals.dialogAddCard == false && 
								rootState.modals.dialogChangeStatus == false && 
									rootState.modals.dialogCancelSubscription == false && 
										rootState.modals.dialogCharge == false;
	}
}

export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters
}
